import { Injectable } from '@angular/core';
import { Order } from 'src/app/models/order';
//import { CheckboxItem } from 'sv-chemistry-ng-lib';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Headers, Http, RequestOptions, ResponseContentType } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from 'src/app/models/store';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  //private subject = new Subject<any>();

  constructor(private http: HttpClient, private httpTest: Http, private _userService: UserInfoService) {
  }

  getOrderDetailsForStore(stores: Store[], orderDays : number): Observable<Order[]> {
    //this will create the list of string from the selected retail company.
    let storeIdString = ""
    for (let s = 0; s < stores.length; s++) {
      if (s != 0) {
        storeIdString += ","
      }
      storeIdString += stores[s].storeId + "";
    }

    const url = '/api/files?storeIds=' + storeIdString + '&previousOrderDays=' + orderDays;
    return this.http.get<Order[]>(url).pipe(map(res => res['files']));
  }

  getOrderDetailsFile(id): Observable<any> {
    let url = '/api/files/' + id;

    return this.httpTest.get(url);
  }

  getNoOfDaysToDisplayOrders() {
    let url = '/api/default-previous-order-days';
    return this.http.get(url);
  }

  // success(message: string) {
  //   this.subject.next({ type: 'success', text: message });
  // }

  // error(message: string) {
  //   this.subject.next({ type: 'error', text: message });
  // }

  // getMessage(): Observable<any> {
  //   return this.subject.asObservable();
  // }
}
